module.exports = __webpack_public_path__ + "static/img/yingteerAL1.dc28101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/yingteerAL1.jpg
// module id = m9ny
// module chunks = 0